import _ from "lodash";
import { Types } from "./zktecoActions";

const zktecoReducers = (state, action) => {
    switch (action.type) {
        case Types.ZKTECO_CONNECT: {

            let newState = _.cloneDeep(state);

            newState.integration.timeAttendance = {
                ...newState?.integration?.timeAttendance,
                zkTeco: {
                    ...newState.integration?.timeAttendance?.zkTeco,
                    connecting: action.status
                }
            }

            return newState;
        }
        case Types.ZKTECO_GET_PUNCH_CLOCKS: {

            let newState = _.cloneDeep(state);

            newState.integration.timeAttendance = {
                ...newState?.integration?.timeAttendance,
                zkTeco: {
                    ...newState.integration?.timeAttendance?.zkTeco,
                    punchClocks: action.data
                }
            }

            return newState;
        }
        case Types.ZKTECO_SAVING: {

            let newState = _.cloneDeep(state);

            newState.integration.timeAttendance = {
                ...newState?.integration?.timeAttendance,
                zkTeco: {
                    ...newState.integration?.timeAttendance?.zkTeco,
                    saving: action.status
                }
            }

            return newState;
        }
        case Types.ZKTECO_LOADING: {

            let newState = _.cloneDeep(state);

            newState.integration.timeAttendance = {
                ...newState?.integration?.timeAttendance,
                zkTeco: {
                    ...newState.integration?.timeAttendance?.zkTeco,
                    loading: action.status
                }
            }

            return newState;
        }
        default:
            return state;
    }
};

export default zktecoReducers;